import React from "react";
import { ThemeProvider } from "styled-components";

import Peracto from "@peracto/peracto";
import Config from "@peracto/peracto-config";
import PeractoUser from "@peracto/peracto-user";
import PeractoCatalogue from "@peracto/peracto-catalogue";
import PeractoCommon from "@peracto/peracto-common";
import PeractoContent from "@peracto/peracto-content";
import PeractoLocations from "@peracto/peracto-locations";
import PeractoPromotions from "@peracto/peracto-promotions";

import { buttonVariants } from "./theme/buttonVariants";
import { EditorTheme, AdminTheme } from "./theme";
import { colors, fonts } from "./theme/tailwind";

import blocks from "./blocks";
import { menu } from "./menu";

import compact from "lodash/compact";
import startCase from "lodash/startCase";

import {
    Button,
    Input,
    Textarea,
    Select,
    Checkbox,
    CheckboxGroup,
    Radio,
} from "./Inputs";

import { OrdersView } from "./packages/Catalogue";
import Warranty from "./packages/Warranty";

import "./styles/globals.scss";

const config = new Config({
    api: process.env.REACT_APP_API,
    algolia: {
        applicationId: process.env.REACT_APP_ALGOLIA_APPLICATION_ID,
        searchApiKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
        indexName: process.env.REACT_APP_ALGOLIA_INDEX_NAME,
    },
    modules: [
        PeractoUser(),
        PeractoCommon(),
        PeractoCatalogue({
            OrdersView,
        }),
        PeractoLocations(),
        PeractoPromotions(),
        PeractoContent(),
        Warranty(),
    ],
    editorConfig: {
        theme: {
            ...EditorTheme,
            breakpoints: {
                sm: "100%",
                md: "100%",
                lg: "100%",
                xl: "1360px",
            },
        },
        screens: {
            sm: "100%",
            md: "100%",
            lg: "100%",
            xl: "1360px",
        },
        colorOptions: compact(
            Object.entries(colors).map(([label, value]) => {
                return {
                    label: startCase(label.replaceAll("brand-", "")),
                    value,
                };
            }),
        ),
        headings: [
            {
                model: "hugeHeading",
                title: "Huge Heading",
                class: "hugeHeadingList",
                view: {
                    name: "h1",
                    classes: "heading1-huge",
                },
                converterPriority: "high",
            },
        ],
        fonts,
        locales: ["en_GB"],
        blocks,
        isTailwind: true,
        buttonVariants,
        stylesheets: ["https://use.typekit.net/cyd4oyn.css"],

        inputTypes: {
            Button,
            Input,
            Textarea,
            Select,
            Checkbox,
            CheckboxGroup,
            Radio,
        },
    },
    features: {
        dashboard: {
            tables: true,
        },
        shippingServices: {
            deliveryDays: true,
            conditions: true,
        },
        products: {
            exportProductData: true,
            productVariants: true,
            currencySymbols: {
                rrp: "€",
                price: "€",
                salePrice: "€",
                clearancePrice: "€",
            },
        },
        content: {
            productRelationships: {
                article: true,
            },
        },
        orders: {
            exportOrderData: true,
        },
        user: {
            userGroups: true,
        },
        countries: {
            manageCountries: true,
        },
    },
    menu,
});

const App = () => (
    <ThemeProvider theme={AdminTheme}>
        <Peracto config={config} />
    </ThemeProvider>
);

export default App;
